/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioTestResult } from './InternalApiScenarioTestResult';
import {
    InternalApiScenarioTestResultFromJSON,
    InternalApiScenarioTestResultFromJSONTyped,
    InternalApiScenarioTestResultToJSON,
    InternalApiScenarioTestResultToJSONTyped,
} from './InternalApiScenarioTestResult';

/**
 * 
 * @export
 * @interface InternalApiScenarioTestResultsPage
 */
export interface InternalApiScenarioTestResultsPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResultsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResultsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioTestResultsPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiScenarioTestResult>}
     * @memberof InternalApiScenarioTestResultsPage
     */
    content: Array<InternalApiScenarioTestResult>;
}

/**
 * Check if a given object implements the InternalApiScenarioTestResultsPage interface.
 */
export function instanceOfInternalApiScenarioTestResultsPage(value: object): value is InternalApiScenarioTestResultsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiScenarioTestResultsPageFromJSON(json: any): InternalApiScenarioTestResultsPage {
    return InternalApiScenarioTestResultsPageFromJSONTyped(json, false);
}

export function InternalApiScenarioTestResultsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioTestResultsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiScenarioTestResultFromJSON)),
    };
}

export function InternalApiScenarioTestResultsPageToJSON(json: any): InternalApiScenarioTestResultsPage {
    return InternalApiScenarioTestResultsPageToJSONTyped(json, false);
}

export function InternalApiScenarioTestResultsPageToJSONTyped(value?: InternalApiScenarioTestResultsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiScenarioTestResultToJSON)),
    };
}

